export enum InsureIQImportSource {
  ALL = 'All',
  IMPORTED = 'Imported',
  MANUAL = 'Manual',
}
